import { render, staticRenderFns } from "./quickSet.vue?vue&type=template&id=67085692&scoped=true&"
import script from "./quickSet.vue?vue&type=script&lang=js&"
export * from "./quickSet.vue?vue&type=script&lang=js&"
import style0 from "./quickSet.vue?vue&type=style&index=0&id=67085692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67085692",
  null
  
)

export default component.exports